import { render, staticRenderFns } from "./OrdersReportExportModal.vue?vue&type=template&id=0d0b242d"
import script from "./OrdersReportExportModal.vue?vue&type=script&lang=ts"
export * from "./OrdersReportExportModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports